<template>
  <div class="newHome">
    <baseBg bgUrl="newbg"></baseBg>
    <div class="newHomeNav w-main">
      <span
        :class="{ spanAct: pags.categoryId === item.id }"
        @click="toPage(item.id)"
        v-for="(item, index) in newData"
        :key="index"
        >{{ item.name }}</span
      >
      <!-- <span :class="{ spanAct: pags.categoryId === 'page3' }" @click="toPage('page3')">论坛沙龙</span> -->
    </div>
    <div class="line w-main"></div>
    <div class="he50"></div>
    <div class="he40"></div>
    <page1 :list="list" :tabName="tabName"></page1>
    <!-- <page3 :listPage3="listPage3" v-if="pags.categoryId === 'page3'" /> -->
    <el-pagination
      background
      layout="prev, pager, next"
      :total="pags.total"
      :page-size.sync="pags.pageSize"
      class="pageBox"
      @current-change="changePage"
    ></el-pagination>
    <div class="he50"></div>
  </div>
</template>

<script>
import baseBg from "@/components/pc/base/bg.vue";
import page1 from "./pages/page1";
// import page3 from "./pages/page3";
import {
  getCategoryList,
  newsGetNewsList,
  getActivityList
} from "@/api/api.js";

export default {
  data() {
    return {
      newData: [],
      pags: {
        pageNum: 1,
        pageSize: 10,
        total: 1,
        categoryId: null
      },
      list: [],
      listPage3: [],
      tabName: ""
    };
  },
  components: {
    baseBg,
    page1
    // page3
    // page2
  },
  watch: {
    $route(newValue) {
      this.toPage(newValue.query.id);
    }
  },
  mounted() {
    this.getCategoryList();
  },
  methods: {
    toPage(val) {
      this.pags.pageNum = 1;
      this.pags.pageSize = 10;
      this.pags.total = 1;
      if (val) {
        // if (val === "page3") {
        //   this.pags.categoryId = val;
        // } else {
        //   }
        this.pags.categoryId = Number(val);
      } else {
        this.pags.categoryId = this.newData[0].id;
      }
      this.newData.forEach(el => {
        if (el.id === this.pags.categoryId) {
          this.tabName = el.name;
        }
      });
      if (val === "page3") {
        this.getActivityList();
      } else {
        this.newsGetNewsList();
      }
    },
    getActivityList() {
      // 沙龙
      getActivityList(this.pags).then(res => {
        if (res.code === 0) {
          this.listPage3 = res.data.list;
          this.pags.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    getCategoryList() {
      getCategoryList().then(res => {
        if (res.code === 0) {
          // 导航分类
          this.newData = res.data;
          this.toPage(this.$route.query.id);
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    changePage(val) {
      this.pags.pageNum = val;
      this.newsGetNewsList();
    },
    newsGetNewsList() {
      newsGetNewsList(this.pags).then(res => {
        if (res.code === 0) {
          this.list = res.data.list;
          this.pags.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.newHome {
  .newHomeNav {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    span {
      display: inline-block;
      margin: 0 30px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: bold;
      color: rgba(52, 52, 52, 1);
      cursor: pointer;
    }
    .spanAct {
      color: rgba(108, 45, 102, 1);
      border-bottom: 2px solid #6c2c66;
    }
  }
  .line {
    height: 1px;
    background: rgba(235, 235, 235, 1);
  }
  .pageBox {
    text-align: center;
    margin: 50px auto 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #0f4581;
  }
}
</style>
